































































































































































import { Component, Mixins } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import PromotionData from '@/data/PromotionData';
import PromotionModule from '@/store/modules/Promotion';
import GeneralModule from '@/store/modules/General';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import S3 from 'aws-s3';

interface IPromotion {
  // _id: string;
  images: string;
  isActive: boolean;
  sort: number;
}

@Component({
  components: {
    Table,
  },
})
export default class Promotion extends Mixins(ErrorHandleMixin) {
  TableHead = PromotionData.TableHead;

  PromotionInstance = getModule(PromotionModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  config = {
    bucketName: 'image-uploader-amb',
    dirName: 'images',
    region: 'ap-southeast-1',
    accessKeyId: 'AKIAQIRWMGKG54CLGNPW',
    secretAccessKey: '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',
  };

  isOpenRemove = false;

  mode = '';

  currentSelection = 0;

  promotion: any;

  searchText = '';

  S3Client = new S3(this.config);

  data: Array<any> = [];

  file: any = null;

  url: any = null;

  isImage = false;

  modalData: IPromotion = {
    // _id: '',
    images: '',
    isActive: true,
    sort: 1,
  };

  async created() {
    await this.fetchPromotion();
    // this.social = resSocial.social;
  }

  async fetchPromotion() {
    const resPromotion = await this.PromotionInstance.FetchPromotion();
    if (resPromotion.status) {
      this.checkError(resPromotion.status);
    } else {
      this.data = [...resPromotion.images];
    }
  }

  openModal(index: number) {
    this.currentSelection = index;
    this.mode = index > -1 ? 'Update' : 'Create';
    this.url = null;
    if (this.mode === 'Update') {
      this.modalData = this.data[index];
      this.modalData.images = this.data[index].path;
    }
  }

  remove(index) {
    this.currentSelection = index;
    this.isOpenRemove = true;
  }

  async submitRemove() {
    this.S3Client
      .deleteFile(`img_promo${this.data[this.currentSelection].path.split('img_promo')[1]}`);
    const res = await this.PromotionInstance.DeletePromotion({
      _id: this.data[this.currentSelection]._id,
    });
    this.checkError(res);
    this.isOpenRemove = false;
    this.fetchPromotion();
  }

  uploadImage(name, files) {
    const [file] = files;
    if (file.size <= 500000) {
      this.file = file;
      this.isImage = true;
    } else {
      this.mode = '';
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: 'File size is too large!',
        alertColor: 'danger',
      });
    }
  }

  async submit() {
    const newFileName = 'img_promo';
    if (this.file) {
      this.GeneralInstance.toggleLoading(true);
      const resS3 = await this.S3Client.uploadFile(this.file, `${newFileName}_${this.file.lastModified}`);
      this.modalData.images = resS3.location;
    }
    if (this.mode === 'Update') {
      const res = await this.PromotionInstance.EditPromotion({
        ...this.modalData,
        _id: this.data[this.currentSelection]._id,
      });
      this.checkError(res);
    } else {
      const res = await this.PromotionInstance.AddPromotion(this.modalData);
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
    this.mode = '';
    this.file = '';
    this.fetchPromotion();
  }
}
